import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function useDocumentMeta() {
    const { t, i18n } = useTranslation('common');

    useEffect(() => {
        const title = t('meta.title');
        const description = t('meta.description');

        if (title) {
            document.title = title;
        }

        if (description) {
            let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
            if (!tag) {
                tag = document.createElement('meta');
                tag.setAttribute('name', 'description');
                document.head.appendChild(tag);
            }
            tag.setAttribute('content', description);
        }

        if (i18n.language) {
            document.documentElement.setAttribute('lang', i18n.language);
        }
    }, [t, i18n.language]);
}
